import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import { resolveApiMediaUrl } from '@/lib/media';

const FALLBACK_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='240' height='336' viewBox='0 0 240 336'%3E%3Crect width='240' height='336' fill='%23E2F2F7'/%3E%3Crect x='28' y='44' width='184' height='248' rx='10' fill='%23A9E1ED' fill-opacity='.45'/%3E%3Cpath d='M78 158h84M78 178h58' stroke='%23113747' stroke-width='8' stroke-linecap='round' opacity='.65'/%3E%3C/svg%3E";

type CatalogImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
};

export function CatalogImage({ src, alt, className }: CatalogImageProps): JSX.Element {
  const [imageSrc, setImageSrc] = useState(resolveApiMediaUrl(src) || FALLBACK_IMAGE);

  useEffect(() => {
    setImageSrc(resolveApiMediaUrl(src) || FALLBACK_IMAGE);
  }, [src]);

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={cn('h-full w-full object-cover', className)}
      loading="lazy"
      onError={() => setImageSrc(FALLBACK_IMAGE)}
    />
  );
}
